  <!-- View Part Side Drawer -->
  <div class="new-drawer-wrapper">
    <div class="row" *ngFor="let part of iReviewPartsViewModelColl; let i = index" (clickOutside)="clickOutside($event)">
      <div class="col-md-12 drawer-header">
        <svg
        class="pull-right cursor-pointer drawer-close-icon"
        (click)="closePartDrawer()"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M3.21967 4.28033C2.92678 3.98744 2.92678 3.51256 3.21967 3.21967C3.51256 2.92678 3.98744 2.92678 4.28033 3.21967L12 10.9393L19.7197 3.21967C20.0126 2.92678 20.4874 2.92678 20.7803 3.21967C21.0732 3.51256 21.0732 3.98744 20.7803 4.28033L13.0607 12L20.7803 19.7197C21.0732 20.0126 21.0732 20.4874 20.7803 20.7803C20.4874 21.0732 20.0126 21.0732 19.7197 20.7803L12 13.0607L4.28033 20.7803C3.98744 21.0732 3.51256 21.0732 3.21967 20.7803C2.92678 20.4874 2.92678 20.0126 3.21967 19.7197L10.9393 12L3.21967 4.28033Z"
          fill="currentColor"
        />
      </svg>
         <h2 class="rfq-heading">{{ part?.partName | titlecase }}</h2>
         <h2 class="f-20 rfq-id">{{ part?.partNumber | titlecase }}</h2>
      </div>
      <div class="col-md-12 m-t-16">
         <div class="d-flex align-items-center mb-3">
          <button class="view_rfq_btn rfq_btn" (click)="editQuote(part.rfqId)">Edit Part Quote</button>
        </div>
      </div>
      <div class="col-sm-12 overview-panel">
        <div class="overview">
          Overview
        </div>
        <div class="overview-item">
          <b class="overview-label">New or Existing Part?</b>
          <p class="overview-value">
            {{
              part.isExistingPart == false
                ? "New Part"
                : part.isExistingPart == true
                ? "Existing Part"
                : "N/a"
            }}
          </p>
        </div>
        <div class="overview-item">
          <b class="overview-label">Quantity Unit</b>
          <p class="overview-value">{{ part?.partQtyUnitName || "N/A" }}</p>
        </div>
        <div class="overview-item">
          <b class="overview-label">Manufacturing Process</b>
          <p class="overview-value">{{ part?.parentCategoryName || "N/A" }}</p>
        </div>
        <div class="overview-item">
          <b class="overview-label">Manufacturing Technique</b>
          <p class="overview-value">{{ part?.childCategoryName || "N/A" }}</p>
        </div>
        <div class="overview-item">
          <b class="overview-label">Material</b>
          <p class="overview-value">{{ part?.materialName || "N/A" }}</p>
        </div>
        <div class="overview-item">
          <b class="overview-label">Post Production Process</b>
          <p class="overview-value">{{ part?.postProductionProcessName || "N/A" }}</p>
        </div>
        <div class="overview-item">
          <b class="overview-label">Dimensions</b>
          <p class="overview-value">{{ part?.dimensions || "N/A" }}</p>
        </div>
        <div class="overview d-flex justify-content-between align-items-center mt-4">
          <div>Part Files</div>
          <div>
            <a (click)="
              downloadAllFiles(
                part.partsFiles,
                part.rfqPartFile,
                part.partId,
                part.rfqId,
                'isFileDownloaded1'
              )
            ">Download All</a>
          </div>
        </div>
        <div class="file-download d-flex justify-content-between align-items-center" *ngFor="let file of part?.partsFiles">
          <div class="file-name">{{ file | shortAwsName : "23" }}</div>
          <div>
            <a (click)="downloadS3File(file, true)" title="Download - {{ file | originalName }}">
              <img src="assets/icon/download.svg" />
            </a>
          </div>
        </div>
        <div class="file-download d-flex justify-content-between align-items-center" *ngIf="part?.rfqPartFile">
          <div class="file-name">{{ part?.rfqPartFile | shortAwsName : "23" }}</div>
          <div>
            <a (click)="downloadS3File(part.rfqPartFile, true)" title="Download - {{ part?.rfqPartFile }}">
              <img src="assets/icon/download.svg" /></a>
          </div>
        </div>
      </div>
   </div>

  </div>
  <!-- End View Part Side Drawer -->